/**
 * 检查当前是否为暗色主题
 * 
 * 通过解析 userAgent 中的 hxtheme 参数来判断主题模式
 * 
 * @returns {boolean} 如果是暗色主题返回 true，否则返回 false
 * @example
 * ```ts
 * isDark(); // => true (在暗色主题下)
 * isDark(); // => false (在亮色主题下)
 * ```
 */
export function isDark(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const HX_THEME_KEYWORD = 'hxtheme';
  const userAgent = navigator.userAgent;
  const keywordIndex = userAgent.indexOf(HX_THEME_KEYWORD);
  
  if (keywordIndex > -1) {
    const keywordOffset = keywordIndex + HX_THEME_KEYWORD.length + 1;
    const hxthemeValue = userAgent.substring(keywordOffset, keywordOffset + 1);
    if (hxthemeValue && Number(hxthemeValue) === 1) {
      return true;
    }
  }
  
  return false;
} 